import { GetUser } from '@/api/user';
import getAllTiersIdsInUser from '@/services/user/serviceUser';
import * as types from './user-mutation-type';
import { resetState } from '../store';
import * as allTypes from '../mutation-type';
import configUser from '../../configurations/configUser';

function initialState() {
  return {
    dataConnexion: null,
    user: null,
    hash: null,
    tiersId: [],
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach((key) => {
      if (key !== 'hash') state[key] = s[key];
    });
  },
  [allTypes.RESET_NOT_PERSISTED](state) {
    const s = initialState();
    Object.keys(state).forEach((key) => {
      state[key] = s[key];
    });
  },
  [types.SET_DATA_CONNEXION](state, data) {
    state.dataConnexion = data;
  },
  [types.SET_USER](state, data) {
    state.user = data;
  },
  [types.SET_HASH](state, data) {
    state.hash = data;
  },
  [types.SET_TIERS_ID](state, data) {
    state.tiersId = data;
  },
};

const actions = {
  logout() {
    resetState();
  },
  async initUser({ commit, getters }) {
    const user = (await GetUser(getters.userId)).data;
    commit(types.SET_USER, user);
    if (user.role !== configUser.roles.superAdmin) {
      const tiersId = await getAllTiersIdsInUser(user);
      commit(types.SET_TIERS_ID, tiersId);
    }
  },
};

const getters = {
  isConnected: (state) => !!state.user,
  token: (state) => {
    if (state.dataConnexion) return state.dataConnexion.token;
    return null;
  },
  hash: (state) => {
    if (state.user && state.user.role !== configUser.roles.superAdmin) {
      return state.user.hash;
    }
    return state.hash ?? state.user.hash;
  },
  tenantId(state, getters) {
    if (!getters.hash) return null;
    const decode = atob(getters.hash);
    return decode?.split('|')[1];
  },
  tiersId: (state) => {
    return state.tiersId;
  },
  userExtendAllTiersId: (state) => {
    return [
      ...(state.user.extend.tiersId || []),
      ...(state.user.extend.groupeIds || []),
      ...(state.user.extend.enseigneIds || []),
    ];
  },
  nomGroupe: (state) => {
    if (state.user && state.user.role !== configUser.roles.superAdmin) {
      return state.user.extend.nomGroupe;
    }
    return '';
  },
  urlAvatar: (state) => {
    if (state.user && state.user.extend && state.user.extend.avatar) {
      return state.user.extend.avatar;
    }
    return '';
  },
  userId: (state) => {
    if (state.dataConnexion) {
      return state.dataConnexion.id;
    }
    return '';
  },
  prenoms: (state) => {
    if (state.user) {
      return state.user.prenoms;
    }
    return '';
  },
  nom: (state) => {
    if (state.user) {
      return state.user.nom;
    }
    return '';
  },
  email: (state) => {
    if (state.user) {
      return state.user.email;
    }
    return '';
  },
  telephone: (state) => {
    if (state.user && state.user.extend && state.user.extend.telephone) {
      return state.user.extend.telephone;
    }
    return '';
  },
  role: (state) => {
    if (state.user) {
      return state.user.role;
    }
    return '';
  },
  isSuperAdmin: (state) => {
    if (state.user) {
      return state.user.role === configUser.roles.superAdmin;
    }
    return false;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
